import React, { Component } from "react"

import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import ShopPanel from "./EditAttachmentDialog/ShopPanel"
import SelectShopDialog from "../../../shop/SelectShopDialog"

/**
 * attachment
 * 
 * onSaveClick(attachment)
 * onCancelClick
 */

class EditAttachmentDialog extends Component {

    constructor(props) {
        
        super(props)

        this.attachment = global.structuredClone(this.props.attachment)

        this.state = {
            dialog: undefined,
            quantity: String(this.attachment.quantity),
            shop: this.attachment.shop,
        }

    }

    readyToSave() {
        if (!this.state.quantity.length) {
            return false
        }
        if (isNaN(Number(this.state.quantity))) {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog open fullWidth>

            <DialogTitle>
				{this.props.attachment.item.name}
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.quantity}
					label = "Количество"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({quantity: e.target.value})
					}}                    
                />

                <ShopPanel 
                    title = "Магазин"
                    shop = {this.attachment.shop}
                    onSelectShopClick = {() => {
                        this.setState({
                            dialog: <SelectShopDialog
                                item_shops = {(this.attachment && this.attachment.item.shops) ? this.attachment.item.shops : undefined}
                                onSelectClick = {shop => {
                                    this.attachment.shop = shop && shop.id !== -1 ? shop : undefined
                                    this.attachment.shop_id = shop && shop.id !== -1 ? shop.id : undefined
                                    this.setState({dialog: undefined})
                                }}
                                onCancelClick = {() => this.setState({dialog: undefined})}
                            />
                        })
                    }}
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.readyToSave()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onSaveClick === "function") {
                            this.attachment.quantity = this.state.quantity
                            this.props.onSaveClick(this.attachment)
                        }
                    }}
                >Сохранить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default EditAttachmentDialog